module.exports = ".manning-agency-app-content {\n    margin-left: 0;\n}"